import { BrowserRouter, Routes, Route } from "react-router-dom";
import SearchProvider from "../Context/SearchContext";
import { NavBar } from "../NavBar/NavBar";
import { HomePage } from "../../Pages/HomePage/HomePage";
import { BidDetailPage } from "../BidDetailPage/BidDetailPage";
import { ResultsGroup } from "../../Pages/Results/ResultsGroup";
import { RegisterForm } from "../RegisterForm/RegisterForm";
import {
  RequireAuth,
  RequireBidderAuth,
  EligibleForPublishorBid,
  ActiveUsers,
} from "../AuthRouting/AuthRouter";
import { MyProfile } from "../MyProfile/MyProfile";
import { MyBidsPage } from "../MyBidsPage/MyBidsPage";
import { RequirePublishAuth } from "../AuthRouting/AuthRouter";
import { Footer } from "../Footer/Footer";
import { ToastContainer } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import { NotFound } from "../NotFound/NotFound";
import { EditTenderPage } from "../EditTender/EditTenderPage";
import { BidsViewPage } from "../BidsViewPage/BidsViewPage";
import { BidderDetail } from "../BidderDetail/BidderDetail";
import { EditBidPage } from "../EditBids/EditBids";
import PublishTenderStepper from "../PublishTenderStepper/PublishTenderStepper";
import { EsewaFeeVerification } from "../BidFeeVerification/EsewaFeeVerification";
import { PasswordResetPage } from "../../Pages/PasswordReset/PasswordResetPage";
import { UserEmailVerification } from "../UserEmailVerification/UserEmailVerification";
import { PaymentPopUp } from "../PaymentPopUp/PaymentPopUp";
import { MyBidLoader } from "../MyBidLoader/MyBidLoader";
import { SavedBids } from "../../Pages/SavedBids/SavedBids";
import { PettyPage } from "../../Pages/Petty/Petty";
import { SingleNoticePage } from "../../Pages/SingleNoticePage/SingleNoticePage";
import { UserInterest } from "../UserInterest/UserInterest";
import { PricingPlan } from "../PricingPlan/PricingPlan";
import { Login } from "../Login/Login";
import Modal from "react-modal";
import { ModalContext } from "../Context/ModalContext/ModalContext";
import { useContext, useEffect } from "react";
import { ForgetPw } from "../Login/ForgetPw/ForgetPw";
import { KhaltiBidFeeVerification } from "../KhaltiPaymentVerification/KhaltiPaymentVerfication";
import MobilePageCheck from "../MobilePage/MobilePage";
import PublisherPolicy from "../../Pages/Company/PublisherPolicy";
import CompanyPolicy from "../../Pages/Company/CompanyPolicy";
import { useGlobal } from "../Context/GlobalContext";
import { getAllAdvertisements } from "../Api/GetApi";
import { ContactUS } from "../ContactUS/ContactUS";
import Bidder from "../../Pages/Company/BidderPolicy";
import BidderTerm from "../../Pages/Company/BidderTerm";
import { AboutUs } from "../../Pages/Company/AboutUs";
import EditCompanyDetails from "../EditDetails/EditCompanyDetails";

const Router = () => {
  const { loading, userData } = useAuth();
  const { TogglePopUpFlags, popupFlags } = useContext(ModalContext);
  const { setAdvertisement, setLoadingAd } = useGlobal();
  const isMobileView = window.innerWidth < 500;
  const mobileViewAccessRoute = [
    "/contact",
    "/user/registration_verification/",
    "/about-us",
    "/privacy-policy",
    "/publisher-policy",
    "/bidder-policy",
    "/bidder-term" ,
    "/pricing-plan"
  ];

  const customLoginStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "410px",
    },
  };

  const customStylesFP = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "410px",
    },
  };

  const customStylesOrg = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "75%",
      padding: "20px",
      maxHeight: "700px",
    },
  };

  const getAdvertisements = () => {
    getAllAdvertisements()
      .then((res) => {
        setAdvertisement(res.data.data);
      })
      .finally(() => {
        setLoadingAd(false);
      });
  };

  useEffect(() => {
    getAdvertisements();
  }, []);

  return (
    <>
      {isMobileView &&
      !mobileViewAccessRoute.some((str) =>
        window.location.pathname.includes(str)
      ) ? (
        <MobilePageCheck />
      ) : (
        <>
          {loading ? (
            <>
              <div className="spinner">
                <MyBidLoader />
              </div>
            </>
          ) : (
            <>
              <SearchProvider>
                <BrowserRouter>
                  <NavBar />
                  {/* Modal Section */}
                  <Modal
                    isOpen={popupFlags.forgetPw}
                    onRequestClose={() => {
                      TogglePopUpFlags("forgetPw");
                    }}
                    contentLabel="My dialog"
                    style={customStylesFP}
                    ariaHideApp={false}
                  >
                    <ForgetPw />
                  </Modal>

                  <Modal
                    isOpen={popupFlags.login}
                    onRequestClose={() => {
                      TogglePopUpFlags("login");
                    }}
                    contentLabel="My dialog"
                    style={customLoginStyles}
                    ariaHideApp={false}
                  >
                    <Login />
                  </Modal>

                  <Modal
                    isOpen={popupFlags.editCompanyDetail}
                    onRequestClose={() => TogglePopUpFlags("editCompanyDetail")}
                    contentLabel="My dialog"
                    style={customStylesOrg}
                    ariaHideApp={false}
                  >
                    <EditCompanyDetails
                      toggleModal={() => TogglePopUpFlags("editCompanyDetail")}
                      userData={userData}
                    />
                  </Modal>
                  {/* End Modal Section */}

                  {/* Route Section */}
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route
                      path="/user/password_reset/:id"
                      element={<PasswordResetPage />}
                    />
                    <Route
                      path="/user/registration_verification/:id"
                      element={<UserEmailVerification />}
                    />
                    <Route path="/bids/view/:id" element={<BidsViewPage />} />
                    <Route element={<RequireAuth />}>
                      <Route path="/my-profile" element={<MyProfile />} />
                      <Route element={<ActiveUsers />}>
                        <Route
                          path="/tender-notice/:id"
                          element={<SingleNoticePage />}
                        />
                        <Route
                          path="/notices/:id"
                          element={<SingleNoticePage />}
                        />
                      </Route>

                      <Route
                        path={`/pricing-plan/khalti/payment_verification`}
                        element={<KhaltiBidFeeVerification />}
                      />
                      <Route
                        path={`/pricing-plan/esewa/payment_verification`}
                        element={<EsewaFeeVerification />}
                      />
                    </Route>
                    {/* Routes for Bidder */}
                    <Route element={<RequireBidderAuth />}>
                      <Route element={<EligibleForPublishorBid />}>
                        {/* Route when bidder bid  */}
                        <Route
                          path="/tender-bid/:id"
                          element={<BidDetailPage />}
                        />
                      </Route>
                      <Route path="/my-bids" element={<MyBidsPage />} />
                      {/* Route to edit bid tender */}
                      <Route
                        path="/my-bids/edit/:id"
                        element={<EditBidPage />}
                      />
                      <Route
                        path={`/bid-tender/esewa/payment_verification`}
                        element={<EsewaFeeVerification />}
                      />

                      <Route
                        path={"/bid-tender/khalti/payment_verification"}
                        element={<KhaltiBidFeeVerification />}
                      />
                      <Route path="/saved-bids" element={<SavedBids />} />
                    </Route>
                    {/* Routes for Publiusher */}
                    <Route element={<RequirePublishAuth />}>
                      <Route element={<EligibleForPublishorBid />}>
                        <Route
                          path="/publish-tender"
                          element={<PublishTenderStepper />}
                        />
                      </Route>
                      <Route path="/pay" element={<PaymentPopUp />} />
                      <Route path="my-tenders" element={<MyBidsPage />} />
                      <Route
                        path="my-tenders/edit/:id"
                        element={<EditTenderPage />}
                      />
                      <Route
                        path="bids/view/:id/:bidder_id"
                        element={<BidderDetail />}
                      />
                      <Route
                        path={`/publish-tender/esewa/payment_verification/`}
                        element={<EsewaFeeVerification />}
                      />
                      <Route
                        path={`/publish-tender/khalti/payment_verification`}
                        element={<KhaltiBidFeeVerification />}
                      />
                    </Route>
                    <Route path="/pricing-plan" element={<PricingPlan />} />
                    <Route path="/results" element={<ResultsGroup />} />
                    <Route path={"/contact"} element={<ContactUS />} />
                    <Route path="/petty" element={<PettyPage />} />
                    <Route path="/interest/:id" element={<UserInterest />} />
                    <Route path="/register-form" element={<RegisterForm />} />
                    # About Company and Policies
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/privacy-policy" element={<CompanyPolicy />} />
                    <Route
                      path="/publisher-policy"
                      element={<PublisherPolicy />}
                    />
                    <Route path="/bidder-policy" element={<Bidder />} />
                    <Route path="/bidder-term" element={<BidderTerm />} />
                    <Route path="/mobile-view" element={<MobilePageCheck />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                  <ToastContainer />
                  <Footer />
                </BrowserRouter>
              </SearchProvider>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Router;
